import { useCallback } from 'react';
import { debounceWait } from 'appConstants';
import debounce from 'lodash.debounce';

export const useDebouncedSearch = (searchFunction, wait = debounceWait) => {
	const debouncedSearch = useCallback(
		debounce((searchValue) => searchFunction(searchValue), wait),
		[]
	);
	return { debouncedSearch };
};
